// @flow

import {
  needsRefresh,
  setTotalNotificationsCount
} from '../actions/mentordashboard'

export function getSearchResults(
  notifications: Array<Object>,
  searchText: string
): Array<Object> {
  return notifications.filter(
    notification =>
      notification.user.name.toLowerCase().indexOf(searchText.toLowerCase()) >
        -1 ||
      notification.metadata.quest.name
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1
  )
}

export function getLearnerResults(
  notifications: Array<Object>,
  searchText: string
): Array<Object> {
  return notifications.filter(
    notification =>
      notification.user.name.toLowerCase().indexOf(searchText.toLowerCase()) >
      -1
  )
}

export function getQuestResults(
  notifications: Array<Object>,
  searchText: string
): Array<Object> {
  return notifications.filter(
    notification =>
      notification.metadata.quest.name
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) > -1
  )
}

export function onlyUniqueUsers(
  obj: Object,
  index: number,
  self: Array<Object>
): boolean {
  return self.findIndex(t => t.user.name === obj.user.name) === index
}

export function onlyUniqueQuests(
  obj: Object,
  index: number,
  self: Array<Object>
): boolean {
  return (
    self.findIndex(t => t.metadata.quest.id === obj.metadata.quest.id) === index
  )
}

export const getNotificationType = notification => {
  if (notification.type === 'activity_focus_skill_check') {
    return 'focus_skill_check'
  }
  if (
    notification.source_type === 'UserActivityComment' ||
    (notification.source_type === 'UserQuestLogEvent' &&
      notification.type === 'unread_quest_log_messages')
  ) {
    return 'unread_quest_log_messages'
  }

  if (notification.type === 'activity_artifact_assessment') {
    return 'artifact'
  }

  return isArtifactNotification(notification) ? 'artifact' : 'checkpoint'
}

export const isArtifactNotification = notification =>
  // per roadmap item 27B, we never display artifact icons if the course
  // is not artifact-assesment-enabled.
  !notification.courseInfo?.course.artifact_assessment_enabled ||
  Object.keys(notification.additional_resolution_criteria).length === 0
    ? false
    : notification.type === 'student_checkpoint' &&
      notification.metadata.activity.artifact

export async function mentorDashboardNotificationCallback(data) {
  const { dispatch, courses, pastCourses, refresh = true } = this
  let totalNotifications = 0
  const mentorCourses = courses.concat(pastCourses)
  const mentorCourseSectionIds = mentorCourses.map(c => c.course_section_id)

  // filter out courses sections that the mentor is not enrolled in, and sum up the notification counts
  data.active_notification_counts_by_course_section
    .filter(ancbcc => mentorCourseSectionIds.includes(ancbcc.course_section_id))
    .forEach(
      notificationCourse => (totalNotifications += notificationCourse.count)
    )

  dispatch(setTotalNotificationsCount(totalNotifications))

  if (refresh) {
    // notify the mentor if the new notification is in a course the mentor is in
    // ** new quest log notifications don't have activity_course_section_id, but course_section_id
    await dispatch(
      needsRefresh(
        mentorCourseSectionIds.includes(
          data.activity_course_section_id || data.course_section_id
        )
      )
    )
  }
}
